const VOIVODESHIPS = {
    'Dolnosląskie': [16.9216532,51.1270569,150],
    'Kujawsko-pomorskie': [18.0002529,53.1219648,150],
    'Lubelskie' : [22.5701022,51.250559,150],
    'Lubuskie': [15.5040993,51.937312,150],
    'Łódzkie': [19.4569911,51.7687323,150],
    'Małopolskie': [19.997153435836697,50.0469432,150],
    'Mazowieckie': [21.07141112883227,52.2337172,150],
    'Opolskie': [17.929884436033525,50.678792900000005,150],
    'Podkarpackie': [22.009911525182105,50.00715125,150],
    'Podlaskie': [23.147050870161664,53.127505049999996,150],
    'Pomorskie': [18.6452324,54.347629,150],
    'Śląskie': [19.0215852,50.2598987,150],
    'Świętokrzyskie': [20.609914352101452,50.85403585,150],
    'Warmińsko-mazurskie': [20.477781292210345,53.7767239,150],
    'Wielkopolskie': [16.91973259178088,52.4006632,150],
    'Zachodniopomorskie': [14.592912670292268,53.42968095,150],
}

export const VOIVODESHIPS_NAMES = Object.keys(VOIVODESHIPS)
export default VOIVODESHIPS